import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconSettingProfile: React.FC<IconProps> = ({ width = 20, height = 20, color }) => {
    const strokeColor = color || 'var(--secondary-color)';

    return (
        <svg
            width={height}
            height={width}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_83584)">
                <path
                    d="M10 12.5C12.7614 12.5 15 10.2614 15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5Z"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M2.5 16.875C4.01328 14.2602 6.76172 12.5 10 12.5C13.2383 12.5 15.9867 14.2602 17.5 16.875"
                    stroke={strokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_83584">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconSettingProfile;
